<template>
  <div :style="{ direction: $vs.rtl ? 'rtl' : 'ltr' }">
    <span
      class="feather-icon select-none relative switch-publish ml-4"
      title="Pin / Un-Pin Resource"
    >
      <vs-switch v-model="params.data.IsPinned"> </vs-switch>
    </span>
  </div>
</template>

<script>
import moment from "moment-timezone";
import moduleResourceManagement from "@/store/resource-management/moduleResourceManagement.js";
import vSelect from "vue-select";
import ls from "@/common/localStorage";
let Session_Event_TZ = ls.getSessionValueByKey("Session_Event_TZ");
var cn = ls.getSessionEventCollectionName();
var vm;
export default {
  name: "CellRendererActions",
  components: {
    vSelect,
  },
  data() {
    return {
      popupActiveEditResource: false,
      editedResourceName: null,
      editedDescription: null,
      editedResourceType: null,
      editedCoverImageURL: null,
      editedCategoryData: [],
      editedSelectedCategory: null,
      editedResourcePath: null,
      showResourceUpload: false,
      editedUploadedResourcePath: null,
      editedEmbedCode: null,
      showVideoLink: false,
      editedVideoLink: null,
      allCategoryList: [],
      editedFileName: null,
      editedResourceHyperLink: null
    };
  },
  watch: {
    "params.data.IsPinned"() {
      this.$store
        .dispatch("resourceManagement/updatePinnedStatus", {
          id: this.params.Id,
          IsPinned: this.params.data.IsPinned,
        })
        .then(() => {
          this.showChangeStatusSuccess();
        })
        .catch((err) => {
          console.error(err);
        });
    },
  },
  methods: {
    fetchCategoryDataForEdit() {
      this.$store
        .dispatch("resourceManagement/fetchCategory")
        .then((res) => {
          this.editedCategoryData = [];
          res.map((row) => {
            row.ModifiedTime = this.SetTimeByZone(
              new Date(row.CreatedTime.seconds * 1000).toUTCString(),
              Session_Event_TZ
            );
            this.editedCategoryData.push(row.Name);
          });
          this.allCategoryList = res;
        })
        .catch((err) => {
          console.error(err);
        });
    },
    showChangeStatusSuccess() {
      this.$vs.notify({
        color: "success",
        title: "Status Changed",
        text: "Status changed successfully",
      });
    },
        SetTimeByZone: function (strDateTime, timeZone) {
      var date = moment
        .tz(strDateTime, timeZone)
        .format("MMM DD, YYYY hh:mm A");
      return date;
    },
 
  },
  created() {
    if (!moduleResourceManagement.isRegistered) {
      this.$store.registerModule(
        "resourceManagement",
        moduleResourceManagement
      );
      moduleResourceManagement.isRegistered = true;
    }
    this.fetchCategoryDataForEdit();
  },
};
</script>
<style lang="scss">
#page-user-list {
  .user-list-filters {
    .vs__actions {
      position: absolute;
      right: 0;
      top: 50%;
      transform: translateY(-58%);
    }
  }
}
.image-hotspot-info {
  position: absolute;
  width: 423px;
  height: 167px;
  background: #ffff;
  z-index: 999;
  line-height: 25px;
  padding: 10px;
  box-shadow: 0 0 5px rgba(0, 0, 0, 0.6);
  border-radius: 5px;
  bottom: 22px;
  left: 0;
  display: none;
}
.label-info:hover .image-hotspot-info {
  display: block;
}
.hotspot-imagelink-box-wrap {
  display: flex;
  justify-content: flex-start;
  align-items: stretch;
}
.hotspot-imagelink-box-wrap .vs-con-input {
  padding-right: 10px;
}
.hotspot-image-box-wrapper {
  width: 100%;
  height: 241px;
  display: flex;
  justify-content: center;
  align-items: center;
  overflow: hidden;
  border: 1px solid #dfdfdf;
  margin: 10px 0;
}
.hotspot-image-box-wrapper img {
  width: 100%;
}
.label-top {
  display: flex;
  justify-content: flex-start;
  align-items: center;
}
.video-embed-custom-tooltip {
  position: absolute;
  z-index: 99999;
  width: 460px;
  height: 326px;
  padding: 15px;
  box-shadow: 0 0 7px rgba(0, 0, 0, 0.4);
  background: #fff;
  overflow: hidden;
  display: flex;
  justify-content: center;
  align-items: center;
  border-radius: 6px;
  top: 13px;
  display: none;
}
.label-info:hover .video-embed-custom-tooltip {
  display: flex;
}
.file-sec-wrap {
  width: 100%;
  padding: 8px;
  border-radius: 5px;
  background: #e8e8e8;
  margin-bottom: 10px;
  display: inline-block;
}
.file-sec-wrap a {
  display: inline-block;
  vertical-align: middle;
}
.file-sec-wrap img {
  display: inline-block !important;
  vertical-align: middle;
  width: 20px;
  height: 20px;
}
</style>
